import React, { useEffect, useLayoutEffect, useMemo, useRef, useState, } from "react";
import { useMapEffect } from "./mapUtils.js";
import { MapContext } from "./MapContext.js";
const defaultOptions = {
    center: { lat: 0, lng: 0 },
    zoom: 4,
};
export function GoogleMap({ className, style, onClick, onIdle, autoFit, children, ...options }) {
    const ref = useRef(null);
    const [map, setMap] = useState(null);
    useLayoutEffect(() => {
        if (ref.current && !map) {
            setMap(new window.google.maps.Map(ref.current, {
                ...defaultOptions,
                ...options,
            }));
        }
    }, [ref, map]);
    useMapEffect(() => {
        if (map) {
            map.setOptions(options);
        }
    }, [map, options]);
    useEffect(() => {
        if (map) {
            ["click", "idle"].forEach((eventName) => google.maps.event.clearListeners(map, eventName));
            if (onClick) {
                map.addListener("click", onClick);
            }
            if (onIdle) {
                map.addListener("idle", () => onIdle(map));
            }
        }
    }, [map, onClick, onIdle]);
    const bounds = useMemo(() => new google.maps.LatLngBounds(), []);
    const markers = useMemo(() => new Set(), []);
    const ctx = useMemo(() => ({
        map,
        addMarker(marker) {
            markers.add(marker);
            marker.setMap(map);
            const position = marker.getPosition();
            if (position)
                bounds.extend(position);
        },
        removeMarker(marker) {
            markers.delete(marker);
            marker.setMap(null);
        },
        extendBounds(point) {
            if (point)
                bounds.extend(point);
        },
    }), [map]);
    useEffect(() => {
        if (autoFit && map && !bounds.isEmpty()) {
            map.fitBounds(bounds);
        }
    }, [map, autoFit]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: ref, className: className, style: style }),
        map && React.createElement(MapContext.Provider, { value: ctx }, children)));
}
